import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Divider, Drawer, useMediaQuery } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import BusinessIcon from '@material-ui/icons/Business';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import WorlIcon from '@material-ui/icons/Work';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import SettingsIcon from '@material-ui/icons/Settings';

import { Profile, SidebarNav } from './components';
import { Values } from '../../../../values/Values';
import SnackbarCustom from '../../../../components/Compartilhados/Snackbar';
import ProgressFullScreen from '../../../../components/Compartilhados/ProgressFullScreen';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import Box from '@material-ui/core/Box';
import { getUsuarioByLocalStorage } from '../../../../services/UsuarioService';
const timeout = ServiceValues.timeout;
const baseUrl = ServiceValues.base_url_local;
const api = ServiceAxios(baseUrl, timeout);

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    marginTop: 65,
    borderTopRightRadius: 50,
    backgroundColor: '#295138',
    borderColor: Values.cores.cinza,
    [theme.breakpoints.up('lg')]: {
      height: 'calc(100%)'
    }
  },
  root: {
    backgroundColor: '#295138',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    marginLeft: 20
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  },
  backgroundCinza: {
    backgroundColor: Values.cores.cinza
  },
  backgroundCorPrimaria: {
    backgroundColor: Values.cores.corPrimaria
  }
}));

const Sidebar = props => {
  const {
    open,
    variant,
    onClose,
    className,
    getUsuarioLogado,
    usuario,
    setUsuario,
    history,
    ...rest
  } = props;
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [modoAnonimo, setModoAnonimo] = useState(false);

  useEffect(() => {
    const anonimo = JSON.parse(localStorage.getItem('modoAnonimo'));
    setModoAnonimo(anonimo);
  }, []);

  const classes = useStyles();

  useEffect(() => {
    getUsuarioLogado();
  }, []);

  const pages = [
    {
      title: 'Dashboard',
      href: '/dashboard',
      icon: <DashboardIcon />,
      visivel: true
    },
    {
      title: 'Empresas',
      href: '/empresa-list',
      icon: <BusinessIcon />,
      visivel: false
    },
    {
      title: 'Usuarios',
      href: '/usuario-list',
      icon: <PeopleIcon />,
      visivel: !modoAnonimo
    },
    {
      title: 'Filiados',
      href: '/filiado-list',
      icon: <AssignmentIndIcon />,
      visivel: true
    },
    {
      title: 'Armas',
      href: '/arma-list',
      icon: <DoubleArrowIcon />,
      visivel: true
    },
    {
      title: 'Visitas',
      href: '/visita-filiado-list',
      icon: <EventAvailableIcon />,
      visivel: true
    },
    {
      title: 'Insumos',
      href: '/insumo-list',
      icon: <DoubleArrowIcon />,
      visivel: true
    },
    {
      title: 'Fábrica Insumos',
      href: '/fabrica-insumos',
      icon: <SettingsIcon />,
      visivel: true
    },
    {
      title: 'Pacotes',
      href: '/pacote-list',
      icon: <WorlIcon />,
      visivel: true
    },
    {
      title: 'Estoque',
      href: '/estoque-insumo-movimentacao-list',
      icon: <LocalShippingIcon />,
      visivel: true
    }
  ];

  return (
    <Box>
      <Drawer
        anchor="left"
        classes={{
          paper: classes.drawer
        }}
        onClose={onClose}
        open={open}
        variant={variant}>
        <div
          {...rest}
          className={clsx({
            [classes.root]: true,
            [className]: true
          })}>
          <SnackbarCustom
            verticalOrientation="bottom"
            horizontalOrientation="center"
            open={showMessageSnack}
            setOpen={setShowMessageSnack}
            message={messageSnack}
            duration={2000}
            type={typeSnack}
          />
          <ProgressFullScreen open={loading} setOpen={setLoading} />
          <Profile
            usuario={usuario}
            style={{
              marginTop: 20,
              marginBottom: 20
            }}
            history={history}
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            setLoading={setLoading}
          />

          <SidebarNav className={classes.nav} pages={pages} />
        </div>
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
